const DURATION_OPTIONS = [6, 15, 30]

const BANNER_VARIANTS = [
  '300x250',
  '750x200',
  '750x300',
  '970x300',
  '940x600',
  '300x600',
]

export const getOutstreamDurations = () => DURATION_OPTIONS

export const getOutstreamBannerVariants = () => BANNER_VARIANTS
